import React from 'react';

const PillIcon = ({ theme }) => {
  const pillColor = theme === 'dark' ? '#00ff00' : '#cc0000' ;
  
  return (
    <svg width="20" height="20" viewBox="0 0 867 401" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M666.668.323C777.124.32 866.667 89.865 866.666 200.32c.001 110.458-89.542 200.001-200 199.999H200c-110.458.002-200-89.541-200-200C0 89.866 89.544.322 200 .324h466.669zm-.002 333.331-200 .002V66.988h200.001C740.305 66.99 800 126.684 800 200.322c0 73.638-59.696 133.333-133.334 133.333z"
        fill={pillColor}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default PillIcon;
